export const agritechQuestionsES = {
  tier1: [
    {
      question: "¿Qué aporta un biofertilizante a las plantas?",
      answers: [
        "Nutrientes y compuestos naturales que favorecen su crecimiento.",
        "Hormonas que protegen de las hormigas arrieras.",
        "Enzimas que funcionan como el nitrógeno natural.",
        "SPF 60 que protege de la radiación ultravioleta.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Qué es la agricultura urbana?",
      answers: [
        "Cultivar alimentos dentro o cerca de las ciudades.",
        "Cultivar alimentos en fincas y transportarlos a las ciudades.",
        "Cultivar una cultura agría en las ciudades.",
        "La agricultura sólo puede ser rural.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Qué busca una agricultura más sostenible?",
      answers: [
        "Reducir el impacto ambiental usando alternativas como los biofertilizantes.",
        "Reducir el impacto ambiental favoreciendo la importación de productos y herramientas del extranjero.",
        "Ocultar el impacto ambiental del uso excesivo de fertilizantes sintéticos.",
        "Comprar al menor precio y vender al mayor precio.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Qué ventaja puede ofrecer un biofertilizante?",
      answers: [
        "Reducir la dependencia de insumos sintéticos.",
        "Proteger los cultivos contra todas las plagas.",
        "Son funcionalmente lo mismo que un fertilizante químico, pero más barato.",
        "Instalar inteligencia artificial en las plantas.",
      ],
      correctIndex: 0,
    },
    {
      question:
        "¿Por qué pueden ser útiles las microalgas para hacer biofertilizantes?",
      answers: [
        "Porque producen biomasa rica en nutrientes y compuestos bioactivos.",
        "Porque realizan fotosíntesis y producen oxígeno.",
        "Porque viven principalmente en ambientes acuáticos.",
        "Porque son productores primarios en muchos ecosistemas acuáticos.",
      ],
      correctIndex: 0,
    },
  ],

  tier2: [
    {
      question: "¿Qué es un compuesto bioactivo?",
      answers: [
        "Una sustancia natural que puede influir en procesos de la planta.",
        "El nitrógeno es un nutriente esencial para las plantas.",
        "Las proteínas forman parte de la biomasa de las microalgas.",
        "Los biofertilizantes pueden contener distintos compuestos naturales.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Qué puede causar el uso excesivo de insumos sintéticos?",
      answers: [
        "Contaminación y deterioro de los ecosistemas.",
        "Uno no se puede exceder porque el cultivo lo absorbe todo y no llega a las aguas subterráneas.",
        "Solo un gasto innecesario para el agricultor.",
        "Filtración a las aguas subterráneas, pero sin consecuencias ambientales.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Por qué preocupa la escorrentía de fertilizantes?",
      answers: [
        "Porque puede contaminar fuentes de agua cercanas y afectar los ecosistemas alrededor.",
        "Porque los vecinos pueden utilizar la escorrentía para crecer sus cultivos.",
        "Porque el agricultor pierde plata en nutrientes que sus cultivos no absorbieron.",
        "Porque el nitrógeno es difícil de conseguir.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Qué hace que una agricultura sea NO sostenible?",
      answers: [
        "Usar recursos de forma que comprometa su disponibilidad para futuras generaciones.",
        "Satisfacer las necesidades actuales sin agotar los recursos naturales.",
        "Cultivar alimentos localmente para reducir las distancias de transporte y su impacto ambiental.",
        "Reducir impactos ambientales mediante alternativas como los biofertilizantes.",
      ],
      correctIndex: 0,
    },
    {
      question:
        "¿Qué reto presenta el manejo de nutrientes en agricultura urbana?",
      answers: [
        "Aportar lo necesario sin desperdiciar ni contaminar.",
        "Solo los expertos en agricultura pueden manejar correctamente los nutrientes.",
        "Los biofertilizantes requieren grandes cantidades de recursos naturales para producirse.",
        "No hay espacio en la ciudad para la agricultura.",
      ],
      correctIndex: 0,
    },
  ],

  tier3: [
    {
      question:
        "¿Por qué importa reducir las consecuencias ambientales de los fertilizantes?",
      answers: [
        "Porque la degradación del agua, el suelo y los ecosistemas también amenaza la producción agrícola a largo plazo.",
        "Porque los impactos ambientales solo importan cuando reducen inmediatamente la cosecha.",
        "Porque un cultivo productivo compensa cualquier daño causado fuera del terreno agrícola.",
        "Porque los ecosistemas afectados se recuperan siempre al suspender el fertilizante.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Por qué este biofertilizante funciona sin microalgas vivas?",
      answers: [
        "Porque la biomasa conserva nutrientes y compuestos aprovechables.",
        "Porque las células vuelven a crecer después de aplicarlo.",
        "Porque las microalgas son sostenibles, de manera que reviven después del secado.",
        "Porque las microalgas no son seres biológicos.",
      ],
      correctIndex: 0,
    },
    {
      question:
        "¿Cómo puede un biofertilizante favorecer la nutrición vegetal?",
      answers: [
        "Aportando nutrientes y favoreciendo su absorción.",
        "Aportando nutrientes y fotosíntesis a la planta.",
        "Aportando toda el agua que necesita el cultivo.",
        "Aportando microalgas que liberan los mismos nutrientes que un Triple 15.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Por qué debe evaluarse la calidad de un biofertilizante?",
      answers: [
        "Para comprobar que sea seguro, estable y adecuado para su uso.",
        "Porque todo producto biológico contiene microorganismos peligrosos.",
        "Porque un producto natural no necesita comprobar su eficacia.",
        "Porque la calidad depende únicamente de cuánto nitrógeno contiene.",
      ],
      correctIndex: 0,
    },
    {
      question: "¿Por qué es importante desarrollar bioinsumos en Medellín?",
      answers: [
        "Permite crear soluciones adaptadas a necesidades locales y con reducido impacto ambiental.",
        "Garantiza que no se necesitará ningún insumo externo.",
        "Hace innecesario probar tecnologías desarrolladas localmente.",
        "Significa que toda la agricultura podría transferirse a la ciudad.",
      ],
      correctIndex: 0,
    },
  ],
};
